import { Checkbox as FormCheckbox } from 'components/Form/Checkbox/Checkbox'
import { Operator } from '../../../../../../constants'

import Styles from './Checkbox.module.scss'

interface Props {
  checked: boolean
  onChangeOperator: (operator: Operator) => void
  isDisabled?: boolean
}

export const Checkbox = ({ checked, onChangeOperator, isDisabled = false, ...props }: Props) => {
  return (
    <div className={Styles.container}>
      <FormCheckbox
        isDisabled={isDisabled}
        isSelected={checked}
        onChange={() => {
          if (checked) {
            onChangeOperator(Operator.Empty)
          } else {
            onChangeOperator(Operator.NotEmpty)
          }
        }}
        {...props}
        size="md"
        variant="grey"
        className={Styles.checkbox}
      />
    </div>
  )
}
